module.exports = __webpack_public_path__ + "img/profile.5874696c.jpg";